export default __webpack_public_path__ + "static/media/share-icon.df6ae453.svg";